import { parse, STR, OBJ } from "partial-json";

// Support legacy charts that are not in the new format
export const extractEChartJsonFromProps = (props) => {
  const { config, children } = props;

  if (config) {
    try {
      const result = parse(config, STR | OBJ);
      if (Object.keys(result).length > 0) {
        return [result];
      }
    } catch {
      // fall through to escaped-quote fallback
    }
    try {
      return [parse(config.replace(/\\"/g, '"'), STR | OBJ)];
    } catch {
      return [];
    }
  }

  try {
    const originalJSONText =
      children
        // @ts-expect-error
        ?.map((c) => c.data)
        ?.filter(Boolean)
        ?.join("") || "{}";

    // Handle where the LLM returns multiple graphs in the same block
    let jsonText = originalJSONText
      .replaceAll(/}[\s,]*{/g, "},{")
      .replaceAll("\n", "");

    if (!jsonText.startsWith("[")) {
      jsonText = `[${jsonText}`;
    }
    if (!jsonText.endsWith("]")) {
      jsonText = `${jsonText}]`;
    }

    const jsons = JSON.parse(jsonText);

    return jsons.map((spec) => ({ ...spec, title: undefined }));
  } catch (e) {
    return [];
  }
};
